<template>
    <el-select v-model='docInfo'
     	placeholder="请输入内容" filterable remote
     	default-first-option clearable
      	:remote-method="searchDocAuto" :loading="loading"
    	size='small'>
        <el-option v-for="item in docList" :key="item.id"
         :label="(item.realName||'')+' '+(item.phone||'')" :value="item.id">
        </el-option>
    </el-select>
</template>
<script scoped>
	import commonApi from '@/api/common'
	export default {
		name: 'searchDocAuto',
		data() {
            return {
                docList: [], //医生列表
                docInfo: '',
                loading: false
            }
		},
		props: {
			/*
			realName，
			搜索手机号：phone，
			搜索医院名：hospitalName
			 */
		    searchKey: String
		},
		methods: {
    		// 远程搜索医生
			searchDocAuto(e) {
				if(e === ''){ return }
				let params = {
					page: 1,
					pageSize: 20,
					searchKey: this.searchKey,
					searchValue: e
				}
				this.loading = true
		      	commonApi.getDocInfo(params).then(res => {
			        if (res.Success) {
			          this.docList = res.Data.dataList;
			        } else {
			          this.$message.error(res.Msg);
			        }
					this.loading = false
		      	}).catch(res => {
					this.loading = false
		      		this.$message.error('获取医生列表出错！')
		      	})
		    },
	        getDocInfo() {
	        	let data = {
	        		id: this.docInfo
	        	}
	        	return data
	        },
	        init() {
	        	this.docInfo = ''
	        }
		}
	};
</script>

<style type="text/less" lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/searchDocAuto.vue